module.exports = __webpack_public_path__ + "static/media/study 210922.2a2e099f.png";